import {
    USUARI_INICIALITZAR,
    USUARI_INTRODUCCIO_OMPLIR_DADES,
    USUARI_INTRODUCCIO_MODIFICAR_CAMP,
    USUARI_INTRODUCCIO_DESCARTAR_CANVIS
} from '../../../../actions/actionTypes';

export const USUARI_FORMULARI_DADES_EDITADES_ESTAT_INICIAL = {
    nom: null,
    cognom1: null,
    cognom2: null,
    codi: null,
    telefon: null,
    email: null,
    idRol: null,
    codiINEMunicipi: null,
    carrer: null,
    numero: null,
    pis: null,
    porta: null,
    codiPostal: null,
    dataAlta: null,
    dataBaixa: null
};

const editades = (state = USUARI_FORMULARI_DADES_EDITADES_ESTAT_INICIAL, action) => {
    switch (action.type) {
        case USUARI_INICIALITZAR:
            return USUARI_FORMULARI_DADES_EDITADES_ESTAT_INICIAL;

        case USUARI_INTRODUCCIO_OMPLIR_DADES:
            return action.dades;

        case USUARI_INTRODUCCIO_MODIFICAR_CAMP: {
            const { idCamp, valor } = action;
            return { ...state, [idCamp]: valor };
        }

        case USUARI_INTRODUCCIO_DESCARTAR_CANVIS:
            return action.originals;

        default:
            return state;
    }
};

export default editades;



// WEBPACK FOOTER //
// ./src/reducers/usuari/formulari/dades/editades.js